import React, { createContext, useContext, PropsWithChildren } from 'react'
import { useAuth } from '~/contexts/auth'
import { useDashboardsListQuery } from '~/graphql/types'

type Dashboard = {
  name: string
  internalId: string
}

type DashboardsContextData = {
  dashboards: Dashboard[]
  dashboardsLoading: boolean
}

const DashboardsContext = createContext<DashboardsContextData>({
  dashboards: [],
  dashboardsLoading: false,
})

export const DashboardsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { authUser } = useAuth()

  const { data, loading } = useDashboardsListQuery({
    skip: !authUser,
    fetchPolicy: 'network-only',
  })

  return (
    <DashboardsContext.Provider
      value={{
        dashboards: (data?.dashboardsList ?? []) as Dashboard[],
        dashboardsLoading: loading,
      }}
    >
      {children}
    </DashboardsContext.Provider>
  )
}

export const useDashboards = () => useContext(DashboardsContext)
